import React from 'react';
import './index.scss';

const Toggle = ({ isOn, onToggle, disabled = false }) => {
  return (
    <div className={`toggle-switch ${isOn ? 'on' : 'off'} ${disabled ? 'disabled' : ''}`} onClick={onToggle}>
      <input
        type="checkbox"
        checked={isOn}
        onChange={onToggle}
        disabled={disabled}
        className="toggle-input"
      />
      <label className="toggle-label" />
    </div>
  );
};

export default Toggle; 